var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.white)?_c('b-img',{key:"white",staticClass:"company-logo",attrs:{"src":require("@/assets/samsung_wordmark_white.png")}}):_c('b-img',{key:"blue",staticClass:"company-logo",attrs:{"src":require("@/assets/samsung_wordmark.svg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }